/* @flow */
import createDebugger from 'debug';
const debug = createDebugger('app:modules:subscriptions:actions'); // eslint-disable-line no-unused-vars

import {
  FETCH_SUBSCRIPTIONS,
  UNSUBSCRIBE,
} from './action-types.js';

/**
 * Fetch all pending and active subscriptions for companies.
 * Used by anyone to see everything they are subscribed to.
 */
export const fetchSubscriptions = () => ({ type: FETCH_SUBSCRIPTIONS });

/**
 * Unsubscribe user from a data feed that. Used by anyone to unfollow
 * a specific feed.
 */
export const unsubscribe = (guid: string, requiredState: string, origin: ?string) => ({
  type: UNSUBSCRIBE,
  payload: { guid, requiredState, origin },
});



// WEBPACK FOOTER //
// ./src/app/modules/subscriptions/actions.js